import React from "react";
import "./Technical.css";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";

export default function AllScan(props) {
  const autoSignalBull = props.autoSignalBull;
  const autoSignalBear = props.autoSignalBear;
  const scrSignalBear = props.scrSignalBear;
  const scrSignalBull = props.scrSignalBull;
  const showType = props.showType;
  return (
    <>
      <div className="row">
        <div className="col-sm-6">
          <p className=" highlited_row boldfont text-center">Autosignal</p>
          <div className="row">
            <div className="col-6">
              <button className="btn btn-success mt-4">Bullish</button>
              {ReactHtmlParser(autoSignalBull)}
            </div>
            <div className="col-6">
              <button className="btn btn-danger mt-4">Bearish</button>
              {ReactHtmlParser(autoSignalBear)}
            </div>
          </div>
        </div>

        <div className="col-sm-6">
          <p className=" highlited_row boldfont text-center">Screener</p>
          <div className="row">
            <div className="col-6">
              <button className="btn btn-success mt-4">Bullish</button>
              {ReactHtmlParser(scrSignalBull)}
            </div>
            <div className="col-6">
              <button className="btn btn-danger mt-4">Bearish</button>
              {ReactHtmlParser(scrSignalBear)}
            </div>
          </div>
        </div>
      </div>
      {showType === 0 && (
        <div className="row mt-4">
          <div className="col-12 text-center mt-4">
            <Link
              to="/subscription"
              target="_blank"
              className="btn btn-primary"
            >
              To access All scan service make payment and enjoy data
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
